var Coords2d = /** @class */ (function () {
    function Coords2d(x, y) {
        this.x = x;
        this.y = y;
    }
    Coords2d.prototype.getInterpolatedCoords2d = function (coords2d, fraction) {
        var xOffset = coords2d.x - this.x;
        var yOffset = coords2d.y - this.y;
        return new Coords2d(this.x + (xOffset * fraction), this.y + (yOffset * fraction));
    };
    Coords2d.prototype.getDistance = function (coords2d) {
        return Math.sqrt(Math.pow(this.x - coords2d.x, 2) + Math.pow(this.y - coords2d.y, 2));
    };
    return Coords2d;
}());
export { Coords2d };
